<template>
  <div
    class="country-card skeleton"
  >
    <div
      class="country-card-flag skeleton"
    />

    <div
      class="country-card-details skeleton"
    >
      <h3 />
      <p />
      <p />
      <p />
    </div>
  </div>
</template>

<style lang="sass">
.country-card-flag.skeleton
  background-color: #f0f0f0
  height: 9rem
  animation: loadingColor 3s linear infinite

.country-card-details.skeleton
  > h3
    background-color: #f0f0f0
    height: 1.7rem
    width: 8rem
    animation: loadingColor 3s linear infinite

  > p
    margin-top: 1.5rem
    background-color: #f0f0f0
    height: 1rem
    width: 11rem
    animation: loadingColor 3s linear infinite

  > p + p
    margin-top: 1em

@keyframes loadingColor
  0%
    background-color: #f0f0f0

  30%
    background-color: #fafafa

  50%
    background-color: #f0f0f0

  70%
    background-color: #fafafa

  100%
    background-color: #f0f0f0

</style>
